import React, { FunctionComponent } from 'react';
import { PrimaryLinkModel } from '../navigationItem/models/navigationItem.model';
import MenuLink from './menuLink';
import { withSitecoreContext, Text } from '@sitecore-jss/sitecore-jss-react';
import { TSitecoreContext } from '../../../../types/types';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';
import { googleClickNavEvent } from '../../../../utils/analytics';

const PrimaryLink: FunctionComponent<{
  model: PrimaryLinkModel;
  onClick: () => void;
  sitecoreContext: TSitecoreContext;
  menuTitle?: string;
}> = ({ model, onClick, sitecoreContext, menuTitle }) => {
  const isEEActive = sitecoreContext?.pageEditing;

  if (model.hasSecondaryLinks) {
    return (
      <div className={'navigation-link navigation-link--primary navigation-link--has-secondary'}>
        <RoutableSitecoreLink
          field={model.link}
          className="navigation-link__main-anchor"
          onClick={(): void => {
            onClick();
            googleClickNavEvent('Global Nav', menuTitle, model?.link?.value?.title || model?.link?.value?.text);
          }}
        />
        {model.secondaryLinks.map((secondaryLink) => (
          <MenuLink model={secondaryLink} key={secondaryLink?.id} onClick={onClick} menuTitle={menuTitle} />
        ))}
        {isEEActive ? (
          <Text className="navigation-link__anchor" tag="span" field={model.viewAll} />
        ) : (
          model.hasViewAll && (
            <RoutableSitecoreLink
              field={{ ...model.link, value: { ...model.link.value, text: model.viewAllText } }}
              className="navigation-link__view-all"
              text={'View all'}
              onClick={(): void => {
                onClick();
                googleClickNavEvent('Global Nav', menuTitle, model?.viewAllText);
              }}
            />
          )
        )}
      </div>
    );
  }
  return (
    <RoutableSitecoreLink
      field={model.link}
      className="navigation-link navigation-link--primary"
      onClick={(): void => {
        onClick();
        googleClickNavEvent('Global Nav', menuTitle, model?.link?.value?.title || model?.link?.value?.text);
      }}
    />
  );
};

export default withSitecoreContext()(PrimaryLink);
